@if (show) {
  <div class="dynamic-search-error k-form-error d-block mt-1" role="alert">
    <i class="fas fa-exclamation-circle me-1" aria-hidden="true"></i>
    <span>{{ resolvedMessage }}</span>
  </div>
}
